var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"type":"narrow"}},[_c('Row',[_c('ButtonL',{attrs:{"icon":"chevron-left","text":"KEMBALI","color":"none"},on:{"click":function($event){return _vm.$router.go(-1)}}})],1),_c('ReportTable')],1)}
var staticRenderFns = []

export { render, staticRenderFns }